export default "__VITE_ASSET__DmvLf__$__"